<template>
  <section>
    <v-card
      elevation="1"
      color="#FFF"
    >
      <v-card-title>
        <p class="process-header">
          Issue Status
        </p>
      </v-card-title>
      <v-card-text class="justify-center">
        <v-form
          ref="form"
          v-model="valid"
        >
          <div class="checkout-details">
            <v-radio-group
              v-model="issueStatus"
              row
              class="field-text-style"
              light
              :rules="[(v) => !!v || 'This field is required']"
              @change="isIssueStatusChanged"
            >
              <v-radio
                label="Pending"
                value="pending"
                light
                color="#FF3700"
              >
                <template #label>
                  <span class="input__label">Pending</span>
                </template>
              </v-radio>
              <v-radio
                label="Completed"
                value="completed"
                light
                color="#FF3700"
              >
                <template #label>
                  <span class="input__label">Completed</span>
                </template>
              </v-radio>
            </v-radio-group>
            <v-textarea
              v-if="showReasonField"
              ref="status"
              v-model="pendingReason"
              dense
              :rules="issueStatus === 'pending' ? [(v) => !!v || 'This field is required'] : []"
              filled
              class="field-text-style"
              hint="Only required if Issue Status is 'Pending'."
              persistent-hint
              color="#000000"
              light
              outlined
              label="Reason*"
            />
            <v-textarea
              v-if="showRootCauseField"
              ref="status"
              v-model="rootCause"
              dense
              :rules="issueStatus === 'completed' ? [(v) => !!v || 'This field is required'] : []"
              filled
              class="field-text-style"
              hint="Only required if Issue Status is 'Completed'."
              persistent-hint
              color="#000000"
              light
              outlined
              label="Root Cause of Issue*"
            />
          </div>
        </v-form>
      </v-card-text>
    </v-card>
    <v-btn
      color="#000"
      class="mt-5 btn-style"
      elevation="0"
      @click="issueStatusGathered()"
    >
      Next
    </v-btn>
    <v-btn
      light
      color="#E6E6E6"
      class="mt-3 btn-style"
      elevation="0"
      @click="cancel()"
    >
      Cancel
    </v-btn>
    <centre-spinner
      :loading="loading"
    />
  </section>
</template>

<script>
import spinner from 'src/views/components/SpinnerCentre';
import Constants from 'src/constants';

export default {
  name: 'GatherIssueStatus',
  components: {
    'centre-spinner': spinner,
  },
  data: () => ({
    loading: false,
    valid: false,
    issueStatus: null,
    pendingReason: null,
    rootCause: null,
    showReasonField: false,
    showRootCauseField: false,
  }),
  methods: {
    issueStatusGathered () {
      if (this.$refs.form.validate() === false) {
        this.$store.dispatch('alert/onAlert', {
          message: 'Please fill the required fields before proceeding',
          type: Constants.ALERT_TYPE_ERROR,
        }, { root: true });
        return;
      }
      this.loading = true;
      this.$store.dispatch('swiftuser/saveIssueStatus', {
        status: this.issueStatus,
        pendingReason: this.pendingReason,
        rootCause: this.rootCause,
      });
      setTimeout(() => {
        this.loading = false;
        this.$emit('issue-status-stored');
      }, 1000);
    },
    isIssueStatusChanged () {
      if (this.issueStatus === 'completed') {
        this.pendingReason = null;
        this.showReasonField = false;
        this.showRootCauseField = true;
      } else {
        this.rootCause = null;
        this.showRootCauseField = false;
        this.showReasonField = true;
      }
    },
    cancel () {
        this.loading = true;
        localStorage.removeItem('siteId');
        localStorage.removeItem('scannedTime');
        setTimeout(() => {
          this.$router.push({ name: 'CheckOut' });
        }, 1000);
    },
  },
};
</script>
